import React, { useCallback, useEffect, useState } from "react";
import "./Dailog.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import hidePwdImg from "../../asset/new/icons/hide_passwd_icon.svg";
import showPwdImg from "../../asset/new/icons/show_passwd.svg";

import {
  OtpVerification,
  googleLoginRequest,
  loginRequest,
} from "../../Redux/Slices/AuthSlice";
import { useGoogleLogin } from "@react-oauth/google";
import Icongoogle from "../../asset/new/icons/icongoogle.svg";

const initialValue = {
  email: "",
  password: "",
};

const SignIn = () => {
  const { redirectTo, otpModal } = useSelector((state) => state?.Auth);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [user, setUser] = useState(initialValue);
  const [error, setError] = useState({});
  const [otp, setOtp] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalD, setShowModalD] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Fixed Google Login Hook
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${tokenResponse.access_token}`,
          },
        });
        const userInfo = await res.json();
        responseGoogle(userInfo);
      } catch (error) {
        console.error("Google login failed:", error);
      }
    },
    onError: (error) => console.error("Google Login Error:", error),
  });

  // ---------- Form Validation -------------
  const validation = () => {
    let error = {};
    if (!user.email) {
      error.email = "Email is required";
    } else if (
      !/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        user.email
      )
    ) {
      error.email = "Enter a valid email";
    }
    if (!user.password) {
      error.password = "Password is required";
    }
    return error;
  };

  // ---------- Handle Input Changes ----------
  const postUserData = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
    setError((prev) => ({ ...prev, [name]: "" }));
  };

  // ---------- Submit ----------
  const SubmitInfo = (e) => {
    e.preventDefault();
    let ErrorList = validation();
    setError(ErrorList);

    if (Object.keys(ErrorList).length === 0) {
      const normalizedUser = {
        ...user,
        email: user.email.trim().toLowerCase(),
      };
      dispatch(loginRequest(normalizedUser));
    }
  };


  // ---------- Handle OTP ----------
  const handleOtp = () => {
    const data = {
      email: user.email,
      otp,
      mode: "verify",
    };
    dispatch(OtpVerification(data));
    setShowModal(false);
    redirectUser();
    setOtp("");
  };

  // ---------- Google Auth ----------
  const responseGoogle = (response) => {
    const data = { email: response.email, id: response.sub };
    dispatch(googleLoginRequest(data));
  };

  // ---------- Redirect ----------
  const redirectUser = useCallback(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const role = localStorage.getItem("role");
    const isInLoginPage = window.location.pathname === "/signin";
    const defaultRoute =
      role === "Employer"
        ? "/employer/dashboard"
        : role === "Jobseeker"
          ? "/jobs"
          : "/";

    if (token && isInLoginPage) navigate(defaultRoute);
    if (redirectTo === "/") navigate(defaultRoute);
  }, [navigate, redirectTo]);

  useEffect(() => {
    redirectUser();
    if (otpModal) setShowModal(true);
    document.title = "SignIn | CAJobPortal";
  }, [redirectUser, otpModal]);

  // ---------- Other Handlers ----------
  const handleButtonClick = () => {
    localStorage.removeItem("name");
    setShowModalD(true);
  };

  const closeModal = () => {
    setShowModalD(false);
    setShowModal(false);
    setOtp("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleOtp();
  };

  return (
    <section className="auth-shell">
      <div className="auth-container">
        <div className="auth-card auth-card-signin">
          <div className="auth-header text-center">
            <h3 className="auth-title">Welcome Back</h3>
            <p className="auth-subtitle">Sign in to continue your hiring or job search journey.</p>
          </div>

          <form className="auth-form" onSubmit={SubmitInfo}>
            <div className="auth-switch-text">
              New here?{" "}
              <span onClick={handleButtonClick} className="create-account auth-link-button">
                Create an Account
              </span>

              {showModalD && (
                <div>
                  <input
                    type="checkbox"
                    id="dialog_state"
                    className="dialog_state"
                    checked={showModalD}
                    onChange={() => { }}
                  />
                  <div id="dialog">
                    <label id="dlg-back" htmlFor="dialog_state" />
                    <div id="dlg-wrap">
                      <label
                        id="dlg-close"
                        htmlFor="dialog_state"
                        onClick={closeModal}
                      >
                        x
                      </label>
                      <h3 id="dlg-header">Create an Account ?</h3>
                      <div id="dlg-prompt">
                        <Link to="/signup" className="btn px-sm-4 button1">
                          Join as Job seeker
                        </Link>
                        <Link
                          to="/signup-recruiter"
                          className="btn px-sm-4 button2"
                        >
                          Join as Recruiter
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="form-floating mb-3 auth-field">
              <input
                type="email"
                onChange={postUserData}
                name="email"
                className="form-control"
                id="floatingInput1"
                placeholder="name@example.com"
              />
              <label htmlFor="floatingInput">Email address</label>
              <span className="auth-error-text">{error.email}</span>
            </div>

            <div className="form-floating pwd-container auth-field">
              <input
                type={isRevealPwd ? "text" : "password"}
                onChange={postUserData}
                name="password"
                className="form-control"
                id="floatingPassword"
                placeholder="Password"
              />
              <img
                title={isRevealPwd ? "Hide password" : "Show password"}
                alt="passwd_img"
                src={isRevealPwd ? hidePwdImg : showPwdImg}
                onClick={() => setIsRevealPwd((prev) => !prev)}
              />
              <label htmlFor="floatingPassword">Password</label>
              <span className="auth-error-text">{error.password}</span>
            </div>

            <div className="mt-3 text-end">
              <Link
                to="/reset-account"
                className="auth-inline-link"
              >
                Forgot Password?
              </Link>
            </div>

            <button type="submit" className="btn auth-submit-btn w-100 mt-3">
              Sign in
            </button>

            <div className="auth-separator">or</div>


            <button
              type="button"
              onClick={googleLogin}
              className="btn auth-google-btn w-100 d-flex align-items-center justify-content-center"
            >
              <img src={Icongoogle} alt="Google logo" className="auth-google-icon" />
              Sign in with Google
            </button>
          </form>
        </div>
      </div>

      {/* OTP Modal */}
      {showModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show"
            style={{ display: "block" }}
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5">
                    Verify Your Account
                    <span className="otp-message">
                      Your code was sent to you via email
                    </span>
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  />
                </div>
                <div className="modal-body">
                  <input
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    type="number"
                    inputMode="numeric"
                    className="form-control"
                    placeholder="Enter OTP"
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleOtp}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default SignIn;
